import { useLocation } from "react-router-dom";

const SiteHeader = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <header className="border-b border-divider bg-background">
      <div className="container py-3 md:py-4">
        <a href="/" className="block max-w-xl mx-auto overflow-hidden rounded-md" aria-label="Global Energy Insider — Home">
          {isHome && (
            <h1 className="sr-only">Global Energy Insider — News, Markets &amp; Energy Policy Insights</h1>
          )}
          <div className="relative" style={{ height: '80px' }}>
            <img
              src="/og-image.jpg"
              alt="Global Energy Insider — News, Markets & Energy Policy Insights"
              className="w-full h-auto absolute top-1/2 -translate-y-1/2"
            />
          </div>
        </a>
      </div>
    </header>
  );
};

export default SiteHeader;
